import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_br2h2zxr: FaireBrandEntity = {
  token: "b_br2h2zxr",
  type: "brand",
  name: "West Coast Jewelry",
  avatarUrl:
    "https://cdn.faire.com/fastly/72c9b86d73ecec96fbc37c08d7b4017ce2971e63131a17dcb816d516bde35827.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/14622430901ba34c82da29ddd7bfa97f1399069030bb4f90ea3467013055efb9.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/72c9b86d73ecec96fbc37c08d7b4017ce2971e63131a17dcb816d516bde35827.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/14622430901ba34c82da29ddd7bfa97f1399069030bb4f90ea3467013055efb9.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 130,
  isTopShop: true,
  isInsider: true,
  description:
    "West Coast Jewelry was born in Los Angeles, California in 2007.  From the very beginning, our goal has been to offer affordable fashion jewelry for men & women. Over the past seventeen years, we've taken our passion for style, amazing quality, and affordability and passed it on to millions of satisfied customers. Our collection has a little something for everyone. Pieces that can be worn alone or layered to create your own unique look. We don't think jewelry has to cost a fortune for someone to look fabulous!",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:27.640Z",
    importedBy: "entity-db-cli",
  },
};
